import { render, staticRenderFns } from "./GenericVideoPlayer.vue?vue&type=template&id=924dbe6e&scoped=true&"
import script from "./GenericVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./GenericVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./GenericVideoPlayer.vue?vue&type=style&index=0&id=924dbe6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924dbe6e",
  null
  
)

export default component.exports